var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.107 8.89251L11.3868 3.17657C10.8535 2.64363 10.8535 1.80425 11.3855 1.28464C11.9055 0.751698 12.7455 0.751698 13.2788 1.2833L21.2788 9.27739C21.6134 9.60315 21.7327 10.0723 21.6367 10.5039C21.5682 10.8221 21.385 11.099 21.1329 11.289L13.2657 19.1504C13.0124 19.3902 12.6657 19.5368 12.3191 19.5368L12.3324 19.5514C11.9724 19.5514 11.6257 19.4049 11.3857 19.165C10.8524 18.6454 10.8524 17.7927 11.3724 17.2731V17.2598L17.0792 11.5572H1.66634C0.919674 11.5572 0.333008 10.9577 0.333008 10.2249C0.333008 9.47874 0.919674 8.89251 1.66634 8.89251H17.107Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.01bf246000303e26ae8c416293160331.svg";
export { ForwardRef as ReactComponent };